import { withNamespaces } from 'react-i18next';
import {
    Button,
    Card,
    CardBody,
    Table,
} from 'reactstrap';

const CarrierInformation = ({
    company,
    t,
}) => {
    const rows = [
        { label: 'Legal name', value: company.legalName },
        { label: 'Country', value: company.country },
        { label: 'Established', value: company.established },
        { label: 'Address', value: company.address },
        {
            label: 'Website',
            value: company.website,
            link: `https://${company.website}`,
        },
        { label: 'Email', value: company.email },
        { label: 'Phone', value: company.phone },
    ];

    return (
        <Card>
            <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">{t('Carrier information')}</h5>
                    <Button className="p-0" color="link" size="sm" type="button">
                        {t('Open in new tab')}
                    </Button>
                </div>

                <Table borderless className="mb-0 freight-details-table" size="sm">
                    <tbody>
                        {rows.map((row) => (
                            <tr key={row.label}>
                                <th>{t(row.label)}</th>
                                <td>
                                    {row.link && row.value !== '—' ? (
                                        <a href={row.link} rel="noreferrer" target="_blank">
                                            {row.value}
                                        </a>
                                    ) : row.value}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    CarrierInformation
);
